import React from "react";
import {
  View,
  Text,
  StyleSheet,
  SafeAreaView,
  StatusBar,
} from "react-native";
import { FontFamilies } from "@/constants/Typography";
import { ActionButton } from "@/components/ActionButton";
import { router, Stack } from "expo-router";
import { Ionicons } from "@expo/vector-icons";
import { Image } from "expo-image";

const aiRobotFace = require("@/assets/images/ai-robot-face.png");

const REFUND_TYPES = [
  "Late deliveries",
  "Price match guarantees",
  "Defective products",
  "Double charges",
  "Late fees",
];

const AiRefundIntroScreen = () => {
  const handleContinue = () => {
    router.push("/signup/connect-email");
  };

  return (
    <View style={styles.container}>
      <Stack.Screen options={{ headerShown: false, gestureEnabled: false }} />
      <StatusBar barStyle="dark-content" />
      <SafeAreaView style={styles.safeArea}>
        {/* Content */}
        <View style={styles.content}>
          {/* Header */}
          <View style={styles.headerSection}>
            <Text style={styles.sectionLabel}>AI refund assistant</Text>
            <Text style={styles.title}>AI that gets you refunds</Text>
            <Text style={styles.subtitle}>
              Your personal AI assistant that continuously looks for refunds you
              may be owed. It even calls customer support on your behalf!
            </Text>
          </View>

          {/* Illustration */}
          <View style={styles.illustrationContainer}>
            <View style={styles.robotContainer}>
              <Image source={aiRobotFace} style={styles.robotFace} />
              <View style={styles.speechBubble}>
                <Text style={styles.speechBubbleText}>
                  I'll look for{"\n"}refunds! ✨
                </Text>
              </View>
            </View>
          </View>

          {/* Refund Types List */}
          <View style={styles.refundTypesList}>
            {REFUND_TYPES.map((type, index) => (
              <View key={index} style={styles.refundTypeRow}>
                <Ionicons name="checkmark" size={24} color="#0F9129" />
                <Text style={styles.refundTypeText}>{type}</Text>
              </View>
            ))}
          </View>
        </View>

        {/* Spacer */}
        <View style={styles.spacer} />

        {/* Bottom Section */}
        <View style={styles.bottomSection}>
          <View style={styles.buttonContainer}>
            <ActionButton title="Continue" onPress={handleContinue} />
          </View>
          <Text style={styles.disclaimer}>
            *Refunds not guaranteed with every call
          </Text>
        </View>
      </SafeAreaView>
    </View>
  );
};

export default AiRefundIntroScreen;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#FFFFFF",
  },
  safeArea: {
    flex: 1,
  },
  content: {
    flex: 1,
    paddingHorizontal: 16,
  },
  headerSection: {
    gap: 12,
    marginBottom: 24,
  },
  sectionLabel: {
    fontFamily: FontFamilies.Inter.Medium,
    fontSize: 16,
    lineHeight: 22,
    color: "#0F9129",
    letterSpacing: -0.32,
  },
  title: {
    fontFamily: FontFamilies.Inter.SemiBold,
    fontSize: 32,
    lineHeight: 38,
    color: "#161D14",
    letterSpacing: -0.64,
  },
  subtitle: {
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 16,
    lineHeight: 24,
    color: "rgba(22, 29, 20, 0.7)",
    letterSpacing: 0.16,
  },
  illustrationContainer: {
    backgroundColor: "#F3F3F3",
    borderRadius: 12,
    height: 196,
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 24,
  },
  robotContainer: {
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  robotFace: {
    width: 184,
    height: 184,
  },
  speechBubble: {
    backgroundColor: "#0F9129",
    borderRadius: 16,
    paddingHorizontal: 10,
    paddingVertical: 6,
    position: "absolute",
    top: 25,
    right: -40,
    transform: [{ rotate: "-25deg" }],
  },
  speechBubbleText: {
    fontFamily: FontFamilies.Inter.Medium,
    fontSize: 12,
    lineHeight: 16,
    color: "#FFFFFF",
    textAlign: "center",
  },
  refundTypesList: {
    gap: 12,
  },
  refundTypeRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  refundTypeText: {
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 15,
    lineHeight: 23,
    color: "#000000",
    opacity: 0.7,
  },
  spacer: {
    flex: 1,
  },
  bottomSection: {
    paddingHorizontal: 16,
    borderTopWidth: 1,
    borderTopColor: "#F3F3F3",
    paddingTop: 12,
  },
  buttonContainer: {
    marginBottom: 12,
  },
  disclaimer: {
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 13,
    lineHeight: 19,
    color: "rgba(22, 29, 20, 0.7)",
    textAlign: "center",
  },
});
